import { WorkoutsOverview } from "../../../../../common/components/workout/WorkoutsOverview/WorkoutsOverview";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";
import { useUserWorkoutsPage } from "./hooks/useUserWorkoutsPage";

const EMPTY_STATE = {
  title: "Все още няма тренировки",
  description:
    "Тук ще се появяват всички тренировки на клиента - от групов клас, от лична тренировка с треньор, създадена от него или добавена от вас.",
};

/**
 * Admin user-profile workouts page. Renders the exact three-tab experience the user
 * sees on their own "My Workouts" page (list + statistics + achievements), scoped to
 * the target user. Tapping a workout opens it in admin (editable) mode, read against
 * the target user's history (ПРЕДИШНА, personal records). Staff may add a standalone
 * workout for the client at any time — no active plan or booking needed — through the
 * staff endpoint; the client owns the result. The route sits behind the studio's
 * "Обектът не използва тренировки" setting.
 */
export const UserWorkoutsPage = () => {
  const { userId, userName, listEndpoint, listQueryKey, statistics, achievements } =
    useUserWorkoutsPage();

  return (
    <WorkoutsOverview
      listEndpoint={listEndpoint}
      listQueryKey={listQueryKey}
      statistics={statistics}
      achievements={achievements}
      dialogMode="admin"
      registeredUserName={userName}
      userId={userId}
      showCreateButton
      canCreate
      createForUser={{
        endpoint: endpointsMetadata.workoutPlan.createUserStandalone,
        userId,
      }}
      emptyState={EMPTY_STATE}
    />
  );
};
